
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_104_2_Tabs";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_104_2_Tabs__root","text-medium-normal":"wds_1_104_2_StylableTypography__text-medium-normal","text-small-normal":"wds_1_104_2_StylableTypography__text-small-normal","container":"wds_1_104_2_Tabs__container","itemsContainer":"wds_1_104_2_Tabs__itemsContainer","tab":"wds_1_104_2_Tabs__tab","compact":"wds_1_104_2_Tabs__compact","uniformFull":"wds_1_104_2_Tabs__uniformFull","compactSide":"wds_1_104_2_Tabs__compactSide","tabText":"wds_1_104_2_Tabs__tabText","sideContent":"wds_1_104_2_Tabs__sideContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"sidePadding":"0","sideMargin":"30px","compactSideMargin":"18px"}; 
export var vars = {}; 




